import React from 'react';
import { Target } from 'lucide-react';

const GoalsStep = ({ value, onChange }) => {
  const options = [
    'Onboarding & ramping new hires faster',
    'Coaching teams to consistency',
    'Improving performance through practice',
    'Scaling training across locations',
    'Reducing time managers spend on coaching',
    'Building a culture of continuous learning',
  ];

  const toggleOption = (option) => {
    const currentSelections = value || [];
    if (currentSelections.includes(option)) {
      onChange(currentSelections.filter(o => o !== option));
    } else if (currentSelections.length < 3) {
      onChange([...currentSelections, option]);
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-2">
        <Target className="w-6 h-6 text-cyan-400" />
        <h3 className="text-2xl font-bold text-white">What are your primary goals?</h3>
      </div>
      <p className="text-gray-400 mb-6">Select up to 3 (helps us personalize your demo)</p>
      <div className="space-y-3">
        {options.map((option) => (
          <button
            key={option}
            onClick={() => toggleOption(option)}
            data-testid={`goal-option-${option.toLowerCase().replace(/\s+/g, '-')}`}
            className={`w-full text-left p-4 rounded-xl border-2 transition-all duration-200 ${
              (value || []).includes(option)
                ? 'border-cyan-500 bg-cyan-600/20 text-white'
                : 'border-gray-600 hover:border-gray-500 text-gray-300 hover:bg-gray-800/50'
            }`}
          >
            <div className="flex items-center gap-3">
              <div className={`w-5 h-5 rounded-md border-2 flex items-center justify-center transition-colors ${
                (value || []).includes(option)
                  ? 'border-cyan-500 bg-cyan-500'
                  : 'border-gray-500'
              }`}>
                {(value || []).includes(option) && (
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                )}
              </div>
              {option}
            </div>
          </button>
        ))}
      </div>
      {(value || []).length > 0 && (
        <p className="text-sm text-gray-500 mt-4">
          {(value || []).length}/3 selected
        </p>
      )}
    </div>
  );
};

export default GoalsStep;
